import TemplateNodeChannelSelector from "./TemplateNodeChannelSelector";
import Circle from "./Circle";

import { useDispatch } from 'react-redux';
import A from './ActionCreators';
import { useContext, useState } from 'react';
import { ImageExpansionWindowFocusContext, ExpansionTemplateInfo,ExpansionWindowFocusContext } from './Contexts';
import Adders from './FigureImageExpansionTemplateInsertionLayer';
import ExpansionTemplatePlacementCover from './ExpansionTemplatePlacementCover';

import FigureImageExpansionTemplateNodeValue from './FigureImageExpansionTemplateNodeValue';



const DEFAULT_CHANNEL_COLORS = ["red","lime","blue"]


function splitEveryN(str, n) {
  if (n <= 0) throw new Error("n must be a positive integer");
  return str.match(new RegExp(`.{1,${n}}`, 'g')) || [];
}




function ExpansionSpecLabel({regionId,channels}){

  return (

    <div class="deletable-container expansion-item-id">
      {regionId}
      <div class="sg-row h-center">
        {Array.from(channels||"012").map(cIndex => (
          <div style={{
            background:DEFAULT_CHANNEL_COLORS[cIndex],
            borderRadius:10,
            width:6,
            height:6
          }}>
          </div>
        ))}
      </div>
    </div>
  )

}

function getImagesSlotIdsByNodeId(template){


  let { channels=[] } = template.compact;

  let nodeIds = template.compact.channelGroupStructure.flat()
  let imagesByNodeId = Object.fromEntries(nodeIds.map(nodeId => ([nodeId,[]])))

  Object.entries(channels).forEach(([imageSlotId,value]) => {
    let { placements = [] } = value;
    placements.forEach(nodeId => {
      imagesByNodeId[nodeId].push(imageSlotId)
    })
  })

  return imagesByNodeId;
}


export default function FigureImageExpansionTemplateNode({
  node, nodeId, 
  nodes, templateId,
  setContextMenuConfig,
  onEvent,
}){


  const [ channelSelectorOpen, setChannelSelectorOpen ] = useState(false);

  let dispatch = useDispatch();


  let expansionWindowFocusContext = useContext(ExpansionWindowFocusContext);

  let { onItemClick, focusedExpansionInfo={} } = expansionWindowFocusContext || {};



  let focusedExpansionChannels = focusedExpansionInfo.channels;
  let focusedExpansionRegion = focusedExpansionInfo.region;

  let valuesToSet = {};
  if( focusedExpansionChannels ){
    valuesToSet.channels = focusedExpansionChannels;
  }
  if( focusedExpansionRegion ){
    valuesToSet.regionId = focusedExpansionRegion;
  }


  let { value, style } = node;

  


  let { regionId } = value || {};
  let expansionItemChannels = value?.channelGroup;

  const padding = 0;

  //style.padding || 0;
  //let imagePicker = <TemplateChannelPicker {...{ onEvent, nodeId, value }}/>;


  let expansionTemplateInfo = useContext(ExpansionTemplateInfo);
  let { template } = expansionTemplateInfo || {}
  let { channelGroups } = template;

  let displayInfo = (channelGroups[nodeId]||[]).map(imageChannelId => {

    let { color, label="Channel", defaultValue } = template.compact.channels?.[ imageChannelId ] || {}

    const labelBreakPoint = 15;
    const placeholder = ["Channel " + defaultValue]
    let [lineOne,lineTwo] = label && splitEveryN(label,15).slice(0,2) || placeholder; 

    let resLineTwo = lineTwo && lineTwo.slice(0,-3)+'...';



    let labelList = label.trim() ? [lineOne,resLineTwo] : placeholder; 

    let labelDivs = labelList.map(x => <div>{x}</div>);


    return (
      <div style={{
      }} class="sg-row v-center rel">
        <div style={{
          minWidth:15,
          height:15,
          borderRadius:15,
          border:'1px solid #ccc',
          background:color,
          marginRight:5,
        }}/>

        <div style={{textAlign:'left', whiteSpace:'normal',}} class="">{labelDivs}</div>
      </div>
    )
  })


  const nodeDim = 100;

  let channelSelector = channelSelectorOpen && <TemplateNodeChannelSelector {...{
    setChannelSelectorOpen,
    nodeId, 
      channelGroups,
      onEvent,
  }}/>

  

  return (
    <div 
      nodeId={nodeId}

      onClick={((e)=>{

        console.log("NODEID:" + nodeId);

        e.stopPropagation();
        setChannelSelectorOpen(!channelSelectorOpen);
      })}
      class={
        ("magic-parent sg-col full-width") 
      } 
      style={{
        width:nodeDim,
        height:nodeDim,
        //position:'absolute',
        border:'1px solid #ccc',

      }}>
      

      <div 
        class="rel sg-row v-center full-dim magic-parent deletable-container" 
        style={{

          aspectRatio:'1 / 1',
          top:padding,
          left:padding,
          //width:`calc(100% - ${padding*2}px)`,
          //height:`calc(100% - ${padding*2}px)`,
          alignItems:'center',
          justifyContent:'center',
          border:'1px solid #ccc',
          position:'relative',
          border:'3px solid #aaa',
        }}>
        {channelSelector}
        <div style={{
          //margin:'20%',
        }}> {displayInfo} </div>





      </div>

      




    </div>
  )

}


